<template>
    <el-dialog :title="$t('TABLE_HEADER_Message')"
               top="10vh"
               visible
               width="45%"
               :close-on-click-modal="false"
               append-to-body
               @close="onCancel">
        <div class="messageViewer">
            <template v-if="messageList && messageList.length>0" :loading="loading">
                <el-row class="itemWarp" v-for="(item, index) in messageList" :key="item.id">
                    <el-col :span="18" :class="item.sendUserType == getUser.userType?'floatRight':'floatLeft'">
                        <el-avatar :class="item.sendUserType == getUser.userType?'floatRight':'floatLeft'" size="small" :src="circleUrl"></el-avatar>
                        <div class="messageWarp" :class="item.sendUserType == getUser.userType?'floatRight':'floatLeft'">
                            <div class="messageBy">
                                {{item.sendUserName}} {{ item.sendUserType === '1' ? '(' + item.profitCenter + ')' : '' }}【<span>{{item.createDate | formatDateTime}}</span>】
                            </div>
                            <div class="messageContent" :class="item.sendUserType == getUser.userType?'rightMessage':'leftMessage'">
                                {{item.messageContent}}
                                <el-popconfirm v-if="item.sendUserId===getUser.userId"
                                               :title="$t('msg_delete_sure')" @confirm="deleteMessage(item)">
                                    <i slot="reference" class="el-icon-delete deleteButton leftButton"></i>
                                </el-popconfirm>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <span v-else style="margin-top: 20px">{{$t('INSIGHTS_NO_DATA')}}</span>
        </div>
        <div class="addMessage">
            <el-input
                    type="textarea"
                    resize="none"
                    maxlength="300"
                    show-word-limit
                    :rows="3"
                    :placeholder="$t('ENTER_MESSAGE_CONTENT')"
                    v-model="myMessage"
                    @keyup.enter.exact.native="onConfirm">
            </el-input>
            <i :title="$t('comment_send')" class="el-icon-s-promotion wl-icon-send" @click="onConfirm"></i>
        </div>
    </el-dialog>
</template>
<script>
    import API from '@/api'
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                messageList: [],
                circleUrl: require('@/assets/img/messageboard1.png'),
                squareUrl:  require('@/assets/img/messageboard2.png'),
                myMessage: '',
                loading: true
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser'
            }),
            fileSize() {
                return this.fileList.length
            }
        },
        methods: {
            async getMessageList() {
                try {
                    this.loading = true
                    const params = {
                        groupEntityTopicId: this.initData.id
                    }
                    const { data, code } = await API.pbc.queryPbcMessageBoard(params)

                    if (code == '1') {
                        document.getElementsByClassName('messageViewer')[0].style.opacity = 0
                        this.messageList = data == null ? [] : data
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {}
                finally {
                    this.setScorll()
                }
            },
            async onConfirm() {
                if (!this.myMessage) {
                    this.$message.error(this.$t('MESSAGE_ERROR01'))
                    return false
                }
                try {
                    const params = {
                        groupEntityTopicId: this.initData.id,
                        messageContent: this.myMessage,
                        messageType: this.messageType,
                        siteId: this.siteId
                    }
                    const { data, code } = await API.pbc.sendSinglePbcMessageBoard(params)
                    if (code == '1') {
                        this.getMessageList()
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {}
                finally {
                    this.myMessage = ''
                    this.setScorll()
                    this.onAdd()
                }
            },
            async deleteMessage(item) {
                try {
                    const params = {
                        ids: [item.id]
                    }
                    const { data, code } = await API.pbc.deleteSinglePbcMessageBoard(params)
                    if (code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.getMessageList()
                    } else {
                        this.$message.error(this.$t(code))
                    }
                }
                catch(e) {}
                finally {
                    this.onAdd()
                }
            },
            setScorll() {
                const ele = document.getElementsByClassName('messageViewer')[0]
                const timer = setTimeout(function() {
                    if (ele.scrollHeight > ele.clientHeight) {
                        //设置滚动条到最底部
                        ele.scrollTop = ele.scrollHeight
                    }
                    ele.style.opacity = 1
                    this.loading = false
                    if (timer) {
                        clearTimeout(timer)
                    }
                }, 100)
            }
        },
        mounted() {
            this.getMessageList()
        },
        props: {
            onAdd: Function,
            onCancel: Function,
            initData: [String, Object],
            messageType: String,
            siteId: String,
        }
    }
</script>
<style scoped>
    .messageViewer {
        padding: 10px;
        border: #e9e9eb 1PX solid;
        border-radius: 5px 5px 0 0;
        border-bottom: none;
        background: #f9f9f9;
        height: 50vh;
        overflow-y: scroll;
        text-align: center;
    }

    .itemWarp {
        margin-bottom: 5px;
    }

    .messageWarp {
        padding: 0 10px;
        max-width: 80%;
    }

    .messageBy {
        line-height: 20px;
        position: relative;
    }

    .messageContent {
        padding: 8px 5px;
        line-height: 25px;
        border-radius: 5px;
        text-align: left;
        position: relative;
        word-break: break-word
    }

    .floatLeft {
        float: left;
        text-align: left;
    }

    .floatRight {
        float: right;
        text-align: right;
    }

    .leftMessage {
        background: #a8c8e7;
        border: #a8c8e7 1PX solid;
    }

    .rightMessage {
        background: #ffffff;
        border: #8c939d 1PX solid;
    }

    .addMessage {
        border: #e9e9eb 1PX solid;
        border-radius: 0 0 5px 5px;
        position: relative;
        padding-bottom: 36px;
    }

    .addMessage ::v-deep .el-textarea__inner {
        border: none;
    }

    .addMessage ::v-deep .el-textarea__inner:hover {
        border: none;
    }

    .wl-icon-send {
        font-size: 20px;
        line-height: 26px;
        padding: 0 3px;
        background-color: #409EFF;
        color: #ffffff;
        border-radius: 13px;
        border: #409EFF 1PX solid;
        cursor: pointer;
        position: absolute;
        bottom: 10px;
        right: 10px;
    }

    .deleteButton {
        position: absolute;
        top: calc(50% - 7px);
        cursor: pointer;
        color: #dd6161;
    }

    .leftButton {
        left: -20px;
    }

    .rightButton {
        right: -20px;
    }
</style>
